(function () {
  'use strict';

  var PREVIOUS_QTY_KEY = 'msd_sales_boost_previous_qty';
  var EXIT_SEEN_KEY = 'msd_exit_intent_seen';
  var EXIT_DISMISSED_KEY = 'msd_exit_intent_dismissed';
  var EXIT_ACTIVE_KEY = 'msd_exit_intent_active';
  var progressSeen = new WeakSet();
  var lastUnlockSignature = '';

  function getThemeCartUrl(suffix) {
    var cartUrl = window.theme && theme.routes && theme.routes.cart_url ? theme.routes.cart_url : '/cart';
    return cartUrl.replace(/\/$/, '') + suffix;
  }

  function getMinItems() {
    var minItems = window.theme && theme.cart_free_shipping_min_items ? parseInt(theme.cart_free_shipping_min_items, 10) : 2;
    return Number.isFinite(minItems) && minItems > 0 ? minItems : 2;
  }

  function readStoredCart() {
    if (window.theme && theme.Cart && theme.Cart.currentData && typeof theme.Cart.currentData.item_count === 'number') {
      return theme.Cart.currentData;
    }

    if (window.theme && theme.loadedCartData && typeof theme.loadedCartData.item_count === 'number') {
      return theme.loadedCartData;
    }

    try {
      var stored = JSON.parse(localStorage.getItem('cartCurrentData'));
      if (stored && typeof stored.item_count === 'number') return stored;
    } catch (error) {}

    return null;
  }

  function fetchCart() {
    if (!window.fetch) return Promise.resolve(readStoredCart());

    return fetch(getThemeCartUrl('.js'), { credentials: 'same-origin' })
      .then(function (response) {
        return response.ok ? response.json() : readStoredCart();
      })
      .catch(function () {
        return readStoredCart();
      });
  }

  function getCartValue(cart) {
    return cart && typeof cart.total_price === 'number' ? cart.total_price : 0;
  }

  function getCartQty(cart) {
    return cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
  }

  function getPageType() {
    var path = window.location.pathname;
    if (/\/products\//.test(path)) return 'product';
    if (/\/cart\/?$/.test(path)) return 'cart';
    if (/\/collections\//.test(path)) return 'collection';
    return 'page';
  }

  function getProgressState(cart) {
    var qty = getCartQty(cart);
    if (qty >= getMinItems()) return 'unlocked';
    if (qty === 1) return 'one_item';
    if (qty === 0) return 'empty';
    return 'in_progress';
  }

  function track(eventName, properties) {
    var payload = Object.assign({ event: eventName }, properties || {});

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);

    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, properties || {});
    }

    document.dispatchEvent(new CustomEvent('msd:' + eventName, { detail: properties || {} }));
  }

  function trackProgressSeen(cart) {
    var components = document.querySelectorAll('[data-msd-cart-progress]');
    if (!components.length) return;

    components.forEach(function (component) {
      if (progressSeen.has(component)) return;
      progressSeen.add(component);

      track('cart_progress_seen', {
        cart_qty: getCartQty(cart),
        cart_value: getCartValue(cart),
        page_type: getPageType(),
        state: component.getAttribute('data-state') || getProgressState(cart)
      });
    });
  }

  function updateCartState(cart, source) {
    if (!cart) return;

    var qty = getCartQty(cart);
    var previousQty = null;

    try {
      previousQty = sessionStorage.getItem(PREVIOUS_QTY_KEY);
      previousQty = previousQty === null ? null : parseInt(previousQty, 10);
    } catch (error) {}

    if (previousQty !== null && previousQty !== qty) {
      track('cart_quantity_changed', {
        previous_qty: previousQty,
        current_qty: qty,
        cart_value: getCartValue(cart),
        source: source || 'unknown'
      });
    }

    var minItems = getMinItems();
    var unlockSignature = previousQty + ':' + qty + ':' + getCartValue(cart);
    if (previousQty !== null && previousQty < minItems && qty >= minItems && unlockSignature !== lastUnlockSignature) {
      lastUnlockSignature = unlockSignature;
      track('cart_progress_unlocked', {
        previous_qty: previousQty,
        current_qty: qty,
        cart_value: getCartValue(cart)
      });
    }

    try {
      sessionStorage.setItem(PREVIOUS_QTY_KEY, String(qty));
    } catch (error) {}

    trackProgressSeen(cart);
  }

  function refreshCartState(source) {
    return fetchCart().then(function (cart) {
      updateCartState(cart, source);
      return cart;
    });
  }

  function getExitRoot() {
    return document.querySelector('[data-msd-exit-intent-root]');
  }

  function getExitTemplate() {
    var root = getExitRoot();
    return root && root.querySelector('[data-msd-exit-intent-template]') || document.querySelector('[data-msd-exit-intent-template]');
  }

  function hydrateExitTemplate() {
    var root = getExitRoot();
    if (!root) return null;

    var existingModal = root.querySelector('[data-msd-exit-intent-modal]');
    if (existingModal) return existingModal;

    var template = getExitTemplate();
    if (!template || !template.content || !template.content.firstElementChild) return null;

    root.innerHTML = '';
    root.appendChild(template.content.firstElementChild.cloneNode(true));
    return root.querySelector('[data-msd-exit-intent-modal]');
  }

  function fetchExitTemplate() {
    var existing = hydrateExitTemplate();
    if (existing || !window.fetch) return Promise.resolve(existing);

    return fetch(getThemeCartUrl('?view=popup'), { credentials: 'same-origin' })
      .then(function (response) {
        return response.ok ? response.text() : '';
      })
      .then(function (html) {
        if (!html) return null;
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var template = doc.querySelector('[data-msd-exit-intent-template]');
        var root = getExitRoot();

        if (!template || !root) return null;

        root.innerHTML = template.outerHTML;
        return hydrateExitTemplate();
      })
      .catch(function () {
        return null;
      });
  }

  function isExitSuppressedPage() {
    var path = window.location.pathname;
    return /\/(checkout|account|policies|orders)\b/.test(path) || /\/pages\/(contact|contact-us|shipping-policy|refund-policy|return-policy|tracking)/.test(path);
  }

  function hasSeenExitIntent() {
    try {
      return sessionStorage.getItem(EXIT_SEEN_KEY) === 'true' || sessionStorage.getItem(EXIT_DISMISSED_KEY) === 'true';
    } catch (error) {
      return true;
    }
  }

  function setExitSessionFlag(key, value) {
    try {
      sessionStorage.setItem(key, value);
    } catch (error) {}
  }

  function showExitIntent(trigger) {
    if (isExitSuppressedPage() || hasSeenExitIntent()) return;

    refreshCartState('exit_intent_check').then(function (cart) {
      if (getCartQty(cart) !== 1) return;

      fetchExitTemplate().then(function (modal) {
        if (!modal || hasSeenExitIntent()) return;

        modal.hidden = false;
        document.documentElement.classList.add('msd-exit-intent-open');
        setExitSessionFlag(EXIT_SEEN_KEY, 'true');
        setExitSessionFlag(EXIT_ACTIVE_KEY, 'true');

        track('exit_intent_seen', {
          cart_qty: 1,
          cart_value: getCartValue(cart),
          trigger: trigger || 'unknown'
        });

        var closeButton = modal.querySelector('[data-msd-exit-intent-close]');
        if (closeButton) closeButton.focus({ preventScroll: true });
      });
    });
  }

  function closeExitIntent(reason) {
    var modal = document.querySelector('[data-msd-exit-intent-modal]');
    if (!modal || modal.hidden) return;

    modal.hidden = true;
    document.documentElement.classList.remove('msd-exit-intent-open');
    setExitSessionFlag(EXIT_DISMISSED_KEY, 'true');
    setExitSessionFlag(EXIT_ACTIVE_KEY, 'false');

    track('exit_intent_dismissed', { reason: reason || 'dismissed' });
  }

  function wasExitIntentActive() {
    try {
      return sessionStorage.getItem(EXIT_ACTIVE_KEY) === 'true';
    } catch (error) {
      return false;
    }
  }

  function initExitIntent() {
    if (isExitSuppressedPage()) return;

    document.addEventListener('mouseleave', function (event) {
      if (event.clientY <= 0 && !window.matchMedia('(pointer: coarse)').matches) {
        showExitIntent('desktop_exit');
      }
    });

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-msd-exit-intent-close]')) {
        closeExitIntent('close_button');
      }

      if (event.target.closest('.popup-cart__close[data-js-popup-close]')) {
        window.setTimeout(function () {
          showExitIntent('cart_drawer_close');
        }, 350);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeExitIntent('escape');
    });

    if (/\/cart\/?$/.test(window.location.pathname)) {
      window.setTimeout(function () {
        showExitIntent('cart_inactivity');
      }, 30000);
    }
  }

  document.addEventListener('click', function (event) {
    var progressLink = event.target.closest('[data-msd-cart-progress-addon]');
    if (progressLink) {
      var cart = readStoredCart();
      track('cart_progress_addon_click', {
        source: progressLink.getAttribute('data-source') || 'cart_progress',
        product_id: progressLink.getAttribute('data-product-id') || '',
        cart_qty: getCartQty(cart)
      });
    }

    var completeLookProduct = event.target.closest('[data-msd-complete-look-product]');
    if (completeLookProduct && event.target.closest('a, button')) {
      var completeCart = readStoredCart();
      track('complete_the_look_click', {
        source: completeLookProduct.closest('[data-msd-complete-look]') ? completeLookProduct.closest('[data-msd-complete-look]').getAttribute('data-source') : 'complete_the_look',
        product_id: completeLookProduct.getAttribute('data-product-id') || '',
        product_handle: completeLookProduct.getAttribute('data-product-handle') || '',
        cart_qty: getCartQty(completeCart)
      });
    }

    var exitProduct = event.target.closest('[data-msd-exit-intent-product]');
    if (exitProduct && event.target.closest('a, button')) {
      var exitCart = readStoredCart();
      track('exit_intent_addon_click', {
        product_id: exitProduct.getAttribute('data-product-id') || '',
        product_handle: exitProduct.getAttribute('data-product-handle') || '',
        cart_qty: getCartQty(exitCart)
      });
    }

    if (event.target.closest('button[name="checkout"], input[name="checkout"], [data-msd-checkout]')) {
      if (wasExitIntentActive()) {
        track('exit_intent_checkout_click', { cart_qty: getCartQty(readStoredCart()) });
      }
    }
  });

  document.addEventListener('theme:cart::added', function () {
    if (wasExitIntentActive()) {
      track('exit_intent_quick_add_success', { cart_qty: getCartQty(readStoredCart()) });
      closeExitIntent('quick_add_success');
    }

    window.setTimeout(function () {
      refreshCartState('add');
    }, 350);
  });

  document.addEventListener('theme:cart::removed', function () {
    window.setTimeout(function () {
      refreshCartState('remove');
    }, 350);
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches('.js-input-quantity-cart')) {
      window.setTimeout(function () {
        refreshCartState('quantity_change');
      }, 850);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      refreshCartState('load');
      initExitIntent();
    });
  } else {
    refreshCartState('load');
    initExitIntent();
  }
})();
